<template>
  <el-dialog
    ref="ticketDialog"
    title="异常改签-确认行程信息"
    :visible.sync="detailShow"
    :close-on-click-modal="false"
    :before-close="handleClose"
    :append-to-body="true"
    width="68%"
  >
    <el-descriptions title="原班次信息" :column="3">
      <el-descriptions-item label="班次时间">{{ sourceInfoVo.departureTime }}</el-descriptions-item>
      <el-descriptions-item label="司机信息">{{ sourceInfoVo.driver }}</el-descriptions-item>
      <el-descriptions-item label="车辆信息">{{ sourceInfoVo.car }}</el-descriptions-item>
      <el-descriptions-item label="取件费">{{
        sourceInfoVo.receiveFee || '-'
      }}</el-descriptions-item>
      <el-descriptions-item label="运输费">{{
        sourceInfoVo.transportationFee || '-'
      }}</el-descriptions-item>
      <el-descriptions-item label="派件费">{{ sourceInfoVo.sendFee || '-' }}</el-descriptions-item>
      <el-descriptions-item label="下单人手机号">{{
        sourceInfoVo.mobilePhone
      }}</el-descriptions-item>
    </el-descriptions>
    <div style="padding-top: 20px">
      <el-descriptions title="新班次信息" :column="3">
        <el-descriptions-item label="班次时间">{{ newInfo.departureTime }}</el-descriptions-item>
        <el-descriptions-item label="司机信息">{{ newInfo.driver }}</el-descriptions-item>
        <el-descriptions-item label="车辆信息">{{ newInfo.car }}</el-descriptions-item>
        <el-descriptions-item label="取件费">{{ newInfo.receiveFee || '-' }}</el-descriptions-item>
        <el-descriptions-item label="运输费">{{
          newInfo.transportationFee || '-'
        }}</el-descriptions-item>
        <el-descriptions-item label="派件费">{{ newInfo.sendFee || '-' }}</el-descriptions-item>
        <el-descriptions-item label="下单人手机号">{{ newInfo.mobilePhone }}</el-descriptions-item>
      </el-descriptions>
    </div>
    <div class="padding-top-20">
      <el-descriptions title="物品信息" />
      <goodsInfo :expressOrderDetails="changeInfo.expressOrderDetails" />
    </div>
    <div class="margin-y-15 font-light font-16 required position-relative">改签说明</div>
    <el-input
      type="textarea"
      v-model="remarksBackstage"
      placeholder="请填写改签说明"
      :rows="4"
      maxlength="100"
      show-word-limit
    />
    <div slot="footer" class="dialog-footer">
      <el-button size="small" type="danger" @click="cancel">取 消</el-button>
      <el-button type="primary" size="small" @click="handleSubmit">确认改签</el-button>
    </div>
  </el-dialog>
</template>

<script >
import { inject, computed, ref } from '@vue/composition-api';
import goodsInfo from './goods-info.vue';
import { Message } from 'element-ui';
const __sfc_main = {};
__sfc_main.setup = (__props, __ctx) => {
  const remarksBackstage = ref('');
  const detailShow = inject('detailShow');
  const changeInfo = inject('changeInfo');
  const newInfo = computed(() => {
    return changeInfo.value.newFlightPlanInfoVo || {};
  });
  const sourceInfoVo = computed(() => {
    return changeInfo.value.sourceFlightPlanInfoVo || {};
  });
  const emits = __ctx.emit;
  const cancel = () => {
    detailShow.value = false;
    changeInfo.value = {};
  };
  const handleSubmit = () => {
    if (!remarksBackstage.value) {
      Message.warning('请填写改签说明');
      return;
    }
    emits('submit', remarksBackstage.value);
  };
  return {
    remarksBackstage,
    detailShow,
    changeInfo,
    newInfo,
    sourceInfoVo,
    cancel,
    handleSubmit
  };
};
__sfc_main.components = Object.assign({
  goodsInfo
}, __sfc_main.components);
export default __sfc_main;
</script>

<style lang="scss" scoped>
  .required::before {
    content: '*';
    position: absolute;
    left: -10px;
    top: 20%;
    color: #f56c6c;
  }
</style>
